import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { EventStatusEnum } from '@commons/enums/event-status.enum';
import { BusinessEvent } from '@commons/models/domain/BusinessEvent';

@Component({
  selector: 'app-event-item',
  templateUrl: './event-item.component.html',
  styleUrls: ['./event-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventItemComponent implements OnInit {

  @Input() public eventData: BusinessEvent;
  public readonly EVENT_STATUS = EventStatusEnum;

  constructor() { }

  ngOnInit(): void {
  }

}
